/*
 *   File : sip-date.js
 *   Author : https://evoqins.com
 *   Description : SIP date select modal modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { memo, useState } from "react";

// Components
import { Icon } from "../Icon";

// Styles
import Styles from "../../Styles/Component/sip.module.scss";

// Custom data
const NORMALIZED_SIP_DATES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
const SIP_ACTIVE_DATES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];


function SIPDateModal(props) {

    const sipActiveDates = SIP_ACTIVE_DATES || props.sipActiveDates;

    return (
        <div className="position-absolute top-100 end-0 mt-2 z-index-999">
            <div className={`${Styles.sip_day_picker_wrapper}`}>
                <div className="d-flex justify-content-between align-items-center">
                    <p className='mb-0 e-alt-font-lato e-font-16 e-text-chinese-black e-font-weight-700 line-height-24px'>
                        Choose date
                    </p>
                    <Icon icon="close-icon"
                        className='cursor-pointer'
                        size="1.125rem"
                        onPress={props.handleCloseModal} />
                </div>
                <div className="mt-4">
                    <div className={`${Styles.sip_date_wrapper}`}>
                        {
                            NORMALIZED_SIP_DATES.map((date, key) => (
                                <div className={`${props.selectedDate == date ? "e-bg-lavender-light e-text-primary-color" : "e-bg-white e-text-charleston-green"}  
                                    ${sipActiveDates.includes(date) ? "" : "pe-none user-select-none opacity-50"} e-font-14-res d-flex justify-content-center cursor-pointer e-alt-font-lato e-font-weight-400 e-font-16 line-height-20px py-sm-2 px-sm-1 rounded-circle`}
                                    key={key}
                                    onClick={() => props.handleSelectDate(date)}>
                                    {date}
                                </div>
                            ))
                        }
                    </div>


                </div>
            </div>
        </div>
    )
}

export default memo(SIPDateModal);
